import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AGUAppModuleDefinition, AGUNavTone } from '../../app-surface/app-module-definition';
import { ToneOf } from '../../app-surface/nav-tone';
import { SidebarNavLabel } from '../app-sidebar/sidebar-nav-label';

/**
 * The phone bottom tabs (`nav.mtabs`, P/Member_Hub.html:509-515, 846-880, 1908-1917): one 60px tab per module it is given, each in its
 * tool colour with a 3px indicator on the active one. Navigation, so a `<nav>` with `aria-current`, not an ARIA tablist.
 *
 * The surface decides which modules are tabs (Home / Grants / People / Jobs / Saved); this component renders exactly what it is given.
 * A new implementation rather than MJ chrome: MJ ships no bottom-navigation primitive (docs/mj-upstream-defects.md MJ-G10).
 */
@Component({
    standalone: false,
    selector: 'agu-bottom-tabs',
    templateUrl: './bottom-tabs.component.html',
    styleUrl: './bottom-tabs.component.scss',
})
export class AGUBottomTabsComponent {
    @Input() Modules: readonly AGUAppModuleDefinition[] = [];
    @Input() ActiveModuleKey = '';
    /** Tucked away below the viewport while the member scrolls down (P/Member_Hub.html:708-709, 968-975); see `HideTabsOnScroll`. */
    @Input() Hidden = false;

    @Output() ModuleSelected = new EventEmitter<AGUAppModuleDefinition>();
    /**
     * Focus entered the bar while it was tucked away. The stylesheet already slides it back on `:focus-within`; this asks the owner to
     * clear `Hidden` too, so the next scroll rule starts from the bar the member can see (L65).
     */
    @Output() Revealed = new EventEmitter<void>();

    IsActive(module: AGUAppModuleDefinition): boolean { return module.Key === this.ActiveModuleKey; }
    ToneOf(module: AGUAppModuleDefinition): AGUNavTone { return ToneOf(module); }
    LabelOf(module: AGUAppModuleDefinition): string { return SidebarNavLabel(module); }
    Select(module: AGUAppModuleDefinition): void { this.ModuleSelected.emit(module); }
    OnFocusIn(): void { if (this.Hidden) this.Revealed.emit(); }
}
